import styled from 'styled-components';
export const Checkmark = styled.img`
  width: 1rem;
  height: 1rem;
`;

export const PopupTopDecorator = styled.div`
  width: 100%;
  background: white;
  position: absolute;
  height: ${({ theme }) => theme.frameWidth};
  top: ${({ theme }) => '-' +theme.frameWidth};
`;

export const StyledSessionList = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 1.625rem;
  gap: 0;
  border: 2px solid rgba(0, 0, 0, 0.36);
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
`;

export const SessionListContent = styled.div`
  padding: 1.625rem;
  padding-top: 0.75rem;
  width: 100%;
  height: calc(100% - 1.625rem);
  flex-grow: 1;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  justify-content: space-between;
`;

export const SessionListControls = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const InternalSessionList = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.36);
  padding: ${({ theme }) => theme.frameWidth};
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
`;

export const InternalSessionListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.frameWidth};
`;

export const SessionListHint = styled.div`
  font-family: "NeueMachina";
  font-size: 1rem;
  color: white;
  font-weight: 300;
  max-width: 66%;
`;

export const InternalSession = styled.div`
  display: flex;
  cursor: ${({ $locked }) => $locked ? 'auto' : 'pointer'};
  width: 100%;
  padding: 0.5rem;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  background: ${({ theme, $selected, $own, $locked }) => $locked ? 'gray' : ($own ? theme.baseRed : ($selected ? theme.selection : theme.buttonLightBlue))};
  transition: all linear .2s;
  text-transform: uppercase;
  font-family: "BebasNeue";
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;

  &:hover {
    background: ${({ theme, $selected, $locked }) => $locked ? 'gray' : ($selected ? theme.selection : 'white')};
  }
`;

export const InternalSessionInfo = styled.div`
  padding-top: 4px;
  width: 100%;
  color: black;
`;
